import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import styled from 'styled-components';
import buttonStyles, { LinkTextColors } from './buttonStyles.js';
import StyledLink from '../Link/Link.js';

var Button =
/*#__PURE__*/
function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          display = _this$props.display,
          variant = _this$props.variant,
          size = _this$props.size,
          disabled = _this$props.disabled,
          id = _this$props.id,
          href = _this$props.href,
          children = _this$props.children,
          onClick = _this$props.onClick,
          loading = _this$props.loading,
          childRef = _this$props.childRef,
          className = _this$props.className,
          restProps = _objectWithoutProperties(_this$props, ["display", "variant", "size", "disabled", "id", "href", "children", "onClick", "loading", "childRef", "className"]); // If there is an href passed then we make the element a link by default


      var Element = href ? StyledLink : 'button'; // Only pass the dots if it has children, otherwise dangerouslySetInnerHTML will not work

      var childrenDisplay = children && loading ? "".concat(children, "...") : children;
      var propsForLink = Element === StyledLink && href ? {
        underline: 'never',
        color: LinkTextColors[variant]
      } : {};
      return React.createElement(Element, _extends({
        id: id,
        className: className,
        href: href,
        onClick: onClick,
        disabled: disabled,
        ref: childRef
      }, propsForLink, restProps), childrenDisplay);
    }
  }]);

  return Button;
}(Component);

Button.displayName = 'Button';
Button.defaultProps = {
  variant: 'primary',
  size: 'md',
  disabled: false,
  display: 'inline-block'
};
var ButtonWithStyles = styled(Button).withConfig({
  displayName: "Button__ButtonWithStyles",
  componentId: "sc-1phqvxd-0"
})(["", ""], buttonStyles);
ButtonWithStyles.defaultProps = {
  variant: 'primary',
  size: 'md',
  disabled: false,
  display: 'inline-block'
};
ButtonWithStyles.displayName = 'Button';

export default ButtonWithStyles;
export { ButtonWithStyles as Button };
